import PropTypes from "prop-types";

const BadgePill = ({
  label,
  backgroundColor = "#007bff",
  textColor = "#ffffff",
}) => {
  return (
    <span className="badge-pill" style={{ backgroundColor, color: textColor }}>
      {label}
    </span>
  );
};

BadgePill.propTypes = {
  label: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default BadgePill;
